import config from '../config';
import DDLogs from '../DDLogs';
import { clientWithoutInterceptors } from '../utils/http';

export async function getTrueLayerUrl(extraData: object | undefined, env?: string | undefined): Promise<string> {
  const response = await clientWithoutInterceptors.post('/api/generate-true-layer-redirect-url/', {
    env: env || config.get().otsEnv,
    extraData,
  });
  return response.data.url;
}

export async function getStripeUrl(extraData: object | undefined, env?: string | undefined): Promise<string> {
  const response = await clientWithoutInterceptors.post('/api/providers/stripe/generate-redirect-url/', {
    env: env || config.get().otsEnv,
    extraData,
  });
  return response.data;
}

export async function createStripeCreds(accounts: any[] | undefined): Promise<any> {
  const response = await clientWithoutInterceptors.post('/api/providers/stripe/creds', {
    accounts,
  });
  return response.data;
}

export async function authenticateTrueLayerCode(code: string, router?: any): Promise<boolean> {
  try {
    if (router) {
      const currentQuery = { ...router.currentRoute.value.query };
      delete currentQuery.code;
      router.replace({ query: currentQuery });
    }
    const response = await clientWithoutInterceptors.post('/api/authenticate/', {
      code,
    });

    return response.status === 200;
  } catch (error) {
    DDLogs.error('[OTS] Could not authenticate TL code', error);
    return false;
  }
}
